import React from 'react';

export const PageTitle = ({ title, text }) => (
	<section className="page-title">
		<div className="auto-container">
			<h1>{title}</h1>
			<div className="breadcrumb-outer">
				<ul className="bread-crumb clearfix">
					<li className="active">{text}</li>
				</ul>
			</div>
		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/components/ui/PageTitle/PageTitle.js